/**
 * Applies RTL/LTR document attributes shared by the app shell and public pages.
 * Safe when layout-only elements (e.g. #page-topbar) are not mounted.
 */
export function applyDocumentLanguage(lang) {
  const isArabic = lang === "sa"

  if (isArabic) {
    document.body.id = "rtl"
    document.documentElement.setAttribute("dir", "rtl")
  } else {
    document.body.id = ""
    document.documentElement.setAttribute("dir", "ltr")
  }

  document.documentElement.classList.remove("rtl-native-scrollbar-end")

  const mainRtl = document.getElementById("main-content-rtl")
  if (mainRtl) {
    mainRtl.classList.toggle("rtl-content", isArabic)
  }

  const topbar = document.getElementById("page-topbar")
  if (topbar) {
    topbar.classList.toggle("rtl-page-topbar", isArabic)
  }
}
